import './initializeDropkit'; // just an import, this is placed on window object
import '../types';
export const getWebComponentName = (name) => `dk-${name}`;
export const getTheme = () => ({
    productLine: window?.CONFIGS?.APP_THEME, // eslint-disable-line
});
export const getEmbeddedContext = () => new URLSearchParams(window.location.search).get('deviceContext');
